<!-- src/app/leads-list/leads-list.component.html -->
<div class="leads-container">
  <div class="leads-header">
    <!-- <div class="row">
      <div class="col-sm-12 compswitch">
        <div class="switch cswitch">
          <a href="javascript:void(0);" class="optionone compone" [ngClass]="{'active': selectedMatter === 'entity'}"(click)="onClick('entity')"> Entity </a>
          <a href="javascript:void(0);" class="optiontwo comptwo" [ngClass]="{'active': selectedMatter === 'lawyer'}" (click)="onClick('lawyer')"> Lawyers </a>
        </div>
      </div>
    </div> -->

  <!-- <div class="leads-header">
    <div class="management-info">
      <i class="bi bi-people-fill"></i>
      <span>Leads Management</span>
    </div>
  </div> -->
  </div>
    
    <div class="leads-content">
      <div class="list-header">
        <h5>List of Leads</h5>
        
        <div class="list-actions">
          <div class="search-box">
            <div class="input-group">
              <span class="input-group-text bg-transparent"><i class="bi bi-search"></i></span>
              <input 
                type="text" oninput="this.value = this.value.replace(/[^A-Za-z0-9 ]|^ /g,'')"
                class="form-control" 
                placeholder="Search..." 
                [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
            </div>
          </div>
          
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle add-btn" type="button" id="addDropdown" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bi bi-plus"></i> Add
            </button>
            <ul class="dropdown-menu" aria-labelledby="addDropdown">
              <li><a class="dropdown-item" href="javascript:void(0)" (click)="openUploadFileModal()">
                <i class="bi bi-upload"></i> Upload File
              </a></li>
              <li><a class="dropdown-item" href="javascript:void(0)" (click)="openAddLeadModal()">
                <i class="bi bi-person-plus"></i> Add New Lead
              </a></li>
            </ul>
          </div>
        </div>
      </div>
      
    
      <div class="leads-table" *ngIf="filteredLeads.length > 0">
        <table class="table">
          <thead>
            <tr>
              <th class="thdata" scope="col">Name <i class="bi bi-arrow-down-up biarr" (click)="sortingFile('name')"></i> </th>
              <th class="thdata" scope="col">Type <i class="bi bi-arrow-down-up biarr" (click)="sortingFile('category')"></i></th>
              <th class="thdata" scope="col">Email <i class="bi bi-arrow-down-up biarr" (click)="sortingFile('email')"></i></th>
              <th class="thdata" scope="col">Status <i class="bi bi-arrow-down-up biarr" (click)="sortingFile('status')"></i></th>
              <th class="thdata" scope="col">Area of Specialization <i class="bi bi-arrow-down-up biarr" (click)="sortingFile('subcategory')"></i></th>
              <th class="thdata" scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let lead of getPaginatedLeads() | filter:searchTerm">
              <td>{{ lead.category === 'entity' ? lead.name : lead.fullname }}</td>
              <td>{{ lead.category }}</td>
              <td>{{ lead.email }}</td>
              <td>{{ lead.status }}</td>
              <td>{{ getDisplaySubcategory(lead.subcategory) }}</td>
              <td>
                <div class="dropdown actions-dropdown">
                  <button class="btn actions-menu" type="button" id="leadActions{{lead.id}}" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end" [attr.aria-labelledby]="'leadActions' + lead.id">
                    <li><a class="dropdown-item" href="javascript:void(0)" (click)="viewLeadDetails(lead)">
                      <i class="bi bi-eye"></i> &nbsp; View Details
                    </a></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" (click)="openUpdateStatusModal(lead)">
                      <i class="bi bi-pencil-square"></i> &nbsp; Update Status
                    </a></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" (click)="addNotesModal(lead)">
                      <i class="bi bi-plus-square"></i> &nbsp; Add Notes
                    </a></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" (click)="SubscriptionDetails(lead)">
                      <i class="bi bi-bell"></i> &nbsp; Subscription Details
                    </a></li>
                    <li><a class="dropdown-item" href="javascript:void(0)" (click)="confirmDelete(lead.id)">
                      <i class="bi bi-trash"></i> &nbsp; Delete
                    </a></li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="pagination-area" *ngIf="filteredLeads.length > 0">
        <div class="pagination-info">
          {{ getPaginationRange() }}
        </div>
        
        <nav aria-label="Leads pagination">
          <ul class="pagination mb-0">
            <li class="page-item" [ngClass]="{'disabled': currentPage === 1}">
              <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage - 1)">
                <i class="bi bi-chevron-left"></i> Previous
              </a>
            </li>
            
            <li *ngFor="let page of getPageNumbers()" class="page-item" [ngClass]="{'active': page === currentPage}">
              <a class="page-link" href="javascript:void(0)" (click)="changePage(page)">{{ page }}</a>
            </li>
             
            <li class="page-item" [ngClass]="{'disabled': currentPage === getTotalPages() || getTotalPages() === 0}">
              <a class="page-link" href="javascript:void(0)" (click)="changePage(currentPage + 1)">
                Next <i class="bi bi-chevron-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div *ngIf="filteredLeads.length === 0">
        <div colspan="6" class="text-center noleads">No Leads Found!!</div>
      </div>

    </div>


<!-- Show not found message if UID is invalid -->
<!-- <div class="not-found-container" *ngIf="!isValidUid">
  <img src="assets/3793096.jpg" alt="Page Not Found" class="not-found-image">
  <h2>Oops! Page Not Found</h2>
  <p>The page you're looking for wasn't found. Please scan the QR code again to proceed.</p>
</div> -->


<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
</ngx-spinner>
